import React from 'react'
import { useGetErrorStatus } from './index'
import NotFound from '../pages/NotFound'
import ServerError from '../pages/500'

type Props = {
  children: JSX.Element
}
// TODO: 컴포넌트 이름 변경
function ErrorLayoutHandler({ children }: Props) {
  const getErrorStatus = useGetErrorStatus()
  const renderContext = () => {
    if (getErrorStatus >= 500) {
      return <ServerError />
    }
    if (getErrorStatus >= 400) {
      return <NotFound />
    }
    return children
  }
  return renderContext()
}

export default ErrorLayoutHandler
